<template>
            <ion-menu content-id="main-content">
                        <ion-header>
                        <ion-toolbar>
                            <ion-title>Menú</ion-title>
                        </ion-toolbar>
                        </ion-header>
                        <ion-content class="ion-padding">

                          <ion-accordion-group>
                
                          <ion-menu-toggle>
                            <ion-item href="/">
                            <ion-icon :icon="homeOutline" slot="start"></ion-icon>
                            <ion-label>Inicio</ion-label>
                          </ion-item>
                            <ion-item href="tabs/mensajes">
                            <ion-icon :icon="chatbubblesOutline" slot="start"></ion-icon>
                            <ion-label>Mensajes</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/tasks">
                            <ion-icon :icon="checkboxOutline" slot="start"></ion-icon>
                            <ion-label>Tareas</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/tiempos">
                            <ion-icon :icon="timeOutline" slot="start"></ion-icon>
                            <ion-label>Tiempos</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/procesos">
                            <ion-icon :icon="gitBranchOutline" slot="start"></ion-icon>
                            <ion-label>Procesos</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/incidencias">
                            <ion-icon :icon="alertCircleOutline" slot="start"></ion-icon>
                            <ion-label>Incidencias</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/inventario">
                            <ion-icon :icon="cubeOutline" slot="start"></ion-icon>
                            <ion-label>Inventario</ion-label>
                          </ion-item>
                          <ion-item href="organizacion/usuarios">
                            <ion-icon :icon="peopleOutline" slot="start"></ion-icon>
                            <ion-label>Entidades</ion-label>
                          </ion-item>
                        </ion-menu-toggle>


                          <ion-accordion value="financiero">
                            <ion-item slot="header" color="light">
                              <ion-icon :icon="walletOutline" slot="start"></ion-icon>
                              <ion-label>Financiero</ion-label>
                            </ion-item>

                            <div slot="content">
                              <ion-menu-toggle>
                                <ion-item href="financiero/informes">
                                  <ion-icon :icon="barChartOutline" slot="start"></ion-icon>
                                  <ion-label>Informes</ion-label>
                                </ion-item>

                                <ion-item href="financiero/asientos">
                                  <ion-icon :icon="receiptOutline" slot="start"></ion-icon>
                                  <ion-label>Asientos</ion-label>
                                </ion-item>
                                
                                <ion-item href="financiero/presupuestos">
                                  <ion-icon :icon="documentTextOutline" slot="start"></ion-icon>
                                  <ion-label>Presupuestos</ion-label>
                                </ion-item>
                                
                                <ion-item href="financiero/facturas">
                                  <ion-icon :icon="fileTrayFullOutline" slot="start"></ion-icon>
                                  <ion-label>Facturas</ion-label>
                                </ion-item>
                                
                                <ion-item href="financiero/proveedores">
                                  <ion-icon :icon="peopleOutline" slot="start"></ion-icon>
                                  <ion-label>Proveedores</ion-label>
                                </ion-item>

                                <ion-item href="financiero">
                                  <ion-icon :icon="cardOutline" slot="start"></ion-icon>
                                  <ion-label>Nominas & SEPA</ion-label>
                                </ion-item>

                                <ion-item href="financiero/saldos">
                                  <ion-icon :icon="cashOutline" slot="start"></ion-icon>
                                  <ion-label>Saldos</ion-label>
                                </ion-item>

                                <ion-item href="financiero/movimientos-bancarios">
                                  <ion-icon :icon="swapHorizontalOutline" slot="start"></ion-icon>
                                  <ion-label>Movimientos Bancarios</ion-label>
                                </ion-item>

                                <ion-item href="financiero/tickets">
                                  <ion-icon :icon="ticketOutline" slot="start"></ion-icon>
                                  <ion-label>Tickets</ion-label>
                                </ion-item>
                              </ion-menu-toggle>

                              <ion-accordion-group>
                                <ion-accordion value="tpv">
                                  <ion-item slot="header">
                                    <ion-icon :icon="qrCodeOutline" slot="start"></ion-icon>
                                    <ion-label>TPV</ion-label>
                                  </ion-item>
                                  <ion-menu-toggle slot="content">
                                    <ion-item href="financiero/transacciones">
                                      <ion-icon :icon="phonePortraitOutline" slot="start"></ion-icon>
                                      <ion-label>myPos</ion-label>
                                    </ion-item>
                                    <ion-item href="financiero/cecabank">
                                      <ion-icon :icon="businessOutline" slot="start"></ion-icon>
                                      <ion-label>Ceca Bank</ion-label>
                                    </ion-item>
                                    <ion-item href="financiero/productos">
                                      <ion-icon :icon="bagHandleOutline" slot="start"></ion-icon>
                                      <ion-label>Productos (Tienda)</ion-label>
                                    </ion-item>
                                  </ion-menu-toggle>
                                </ion-accordion>
                              </ion-accordion-group>

                            </div>

                          </ion-accordion>


                          <ion-accordion value="third">
                            <ion-item slot="header" color="light">
                              <ion-icon :icon="musicalNotesOutline" slot="start"></ion-icon>
                              <ion-label>Galidancia</ion-label>
                            </ion-item>

                            <ion-menu-toggle slot="content">

                              <ion-item href="galidancia/sesiones">
                                <ion-icon :icon="calendarOutline" slot="start"></ion-icon>
                                <ion-label>Sesiones</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/alquileres">
                                <ion-icon :icon="keyOutline" slot="start"></ion-icon>
                                <ion-label>Alquileres</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/alumnos">
                                <ion-icon :icon="schoolOutline" slot="start"></ion-icon>
                                <ion-label>Alumnos</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/clases">
                                <ion-icon :icon="bookOutline" slot="start"></ion-icon>
                                <ion-label>Actividades</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/staff">
                                <ion-icon :icon="peopleCircleOutline" slot="start"></ion-icon>
                                <ion-label>Staff</ion-label>
                              </ion-item>

                              <ion-item href="tabs/galidancia">
                                <ion-icon :icon="homeOutline" slot="start"></ion-icon>
                                <ion-label>Instalaciones</ion-label>
                              </ion-item>

                              <ion-item href="tabs/cuadromando">
                                <ion-icon :icon="speedometerOutline" slot="start"></ion-icon>
                                <ion-label>Cuadro de mando</ion-label>
                              </ion-item>

                              <ion-item href="tabs/necesidades">
                                <ion-icon :icon="bulbOutline" slot="start"></ion-icon>
                                <ion-label>Necesidades</ion-label>
                              </ion-item>

                              
                              <ion-item href="galidancia/params">
                                <ion-icon :icon="settingsOutline" slot="start"></ion-icon>
                                <ion-label>Configuración</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/anuncios-app-alumnos">
                                <ion-icon :icon="megaphoneOutline" slot="start"></ion-icon>
                                <ion-label>Anuncios App Alumnos</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/calidad">
                                <ion-icon :icon="starOutline" slot="start"></ion-icon>
                                <ion-label>Calidad</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/informes">
                                <ion-icon :icon="statsChartOutline" slot="start"></ion-icon>
                                <ion-label>Informes</ion-label>
                              </ion-item>

                              <ion-item href="galidancia/informes/carts">
                                <ion-icon :icon="cartOutline" slot="start"></ion-icon>
                                <ion-label>Carritos</ion-label>
                              </ion-item>
                            </ion-menu-toggle>

                          </ion-accordion>

                          <ion-accordion value="cuatro">
                            <ion-item slot="header" color="light">
                              <ion-icon :icon="settingsOutline" slot="start"></ion-icon>
                              <ion-label>Configuración</ion-label>
                            </ion-item>

                            <ion-menu-toggle slot="content">

                              <ion-item href="settings/config">
                                <ion-icon :icon="shieldCheckmarkOutline" slot="start"></ion-icon>
                                <ion-label>Usuarios y permisos</ion-label>
                              </ion-item>

                              <ion-item href="organizacion/admin/tipos-acuerdo-economico">
                                <ion-icon :icon="libraryOutline" slot="start"></ion-icon>
                                <ion-label>Tipos de Acuerdo Económico</ion-label>
                              </ion-item>

                              <ion-item href="settings/log">
                                <ion-icon :icon="listOutline" slot="start"></ion-icon>
                                <ion-label>Log</ion-label>
                              </ion-item>

                            </ion-menu-toggle>

                          </ion-accordion>

                          <ion-menu-toggle>
                            <ion-item href="herramientas">
                              <ion-icon :icon="constructOutline" slot="start"></ion-icon>
                              <ion-label>Herramientas</ion-label>
                            </ion-item>
                          </ion-menu-toggle>


                        </ion-accordion-group>



                      </ion-content>

                      <ion-label class="ion-text-center" style="margin-bottom: 1em; font-size: 0.9em;">
                        Hola, {{ currentUserStore().$state.user?.name.split(' ')[0] }}
                        <div>Version  {{ require('../../package.json').version }}</div>
                        <ion-icon :src="logOutOutline" @click="userAuth().logout"></ion-icon>
                      </ion-label>
                    </ion-menu>

  </template>
  
  <script lang="ts">
    import { IonAccordionGroup,IonAccordion,IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu,IonIcon } from '@ionic/vue';
    import { defineComponent,onMounted, ref } from 'vue';
    import { currentUserStore } from '@/stores/currentUser'
    import userAuth from '@/composables/userAuth';
    import {
      alertCircleOutline,
      bagHandleOutline,
      barChartOutline,
      bookOutline,
      bulbOutline,
      businessOutline,
      calendarOutline,
      cardOutline,
      cartOutline,
      cashOutline,
      chatbubblesOutline,
      checkboxOutline,
      constructOutline,
      cubeOutline,
      documentTextOutline,
      fileTrayFullOutline,
      gitBranchOutline,
      homeOutline,
      keyOutline,
      libraryOutline,
      listOutline,
      logOutOutline,
      megaphoneOutline,
      musicalNotesOutline,
      peopleCircleOutline,
      peopleOutline,
      phonePortraitOutline,
      qrCodeOutline,
      receiptOutline,
      schoolOutline,
      settingsOutline,
      shieldCheckmarkOutline,
      speedometerOutline,
      starOutline,
      statsChartOutline,
      swapHorizontalOutline,
      ticketOutline,
      timeOutline,
      walletOutline,
    } from 'ionicons/icons';
  
    export default defineComponent({
      components: { IonAccordionGroup, IonAccordion, IonItem, IonLabel,IonTitle,IonToolbar,IonHeader,IonMenuToggle,IonContent,IonMenu,IonIcon},

      setup() {
        const currentUser = currentUserStore()
        const Auth = userAuth()
        const version = ref<string>('');

        onMounted(async () => {
          const packageJson = await import('../../package.json');
          version.value = packageJson.version;
        });


        return {
          currentUser,
          Auth,
          logOutOutline,
          alertCircleOutline,
          bagHandleOutline,
          barChartOutline,
          bookOutline,
          bulbOutline,
          businessOutline,
          calendarOutline,
          cardOutline,
          cartOutline,
          cashOutline,
          chatbubblesOutline,
          checkboxOutline,
          constructOutline,
          cubeOutline,
          documentTextOutline,
          fileTrayFullOutline,
          gitBranchOutline,
          homeOutline,
          keyOutline,
          libraryOutline,
          listOutline,
          megaphoneOutline,
          musicalNotesOutline,
          peopleCircleOutline,
          peopleOutline,
          phonePortraitOutline,
          qrCodeOutline,
          receiptOutline,
          schoolOutline,
          settingsOutline,
          shieldCheckmarkOutline,
          speedometerOutline,
          starOutline,
          statsChartOutline,
          swapHorizontalOutline,
          ticketOutline,
          timeOutline,
          walletOutline,
          userAuth,
          currentUserStore,
          version
        }
      },
    });
  </script>